//imports
import {
    PM_USERS_RESET_PASSWORD_OPEN_MODAL,
    PM_USERS_RESET_PASSWORD_CLOSE_MODAL,
    PM_USERS_RESET_PASSWORD_REQUEST,
    PM_USERS_RESET_PASSWORD_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    user: null,
    result: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PM_USERS_RESET_PASSWORD_OPEN_MODAL:
            return { ...state, openModal: true, user: action.payload?.id }

        case PM_USERS_RESET_PASSWORD_CLOSE_MODAL:
            return { ...state, openModal: false, user: null }

        case PM_USERS_RESET_PASSWORD_REQUEST:
            return { ...state, loading: true }

        case PM_USERS_RESET_PASSWORD_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "RESET_PASSWORD_USERS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};